import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { Field, useFormState } from 'react-final-form';
import { NewSearchPopupLocations } from './NewSearchPopupLocations';
import { FORM_VALUES } from '../../../utils/helpers/constants';
import { getRegions } from '../../../api/queries';
import { ErrorField } from '../../ui/Input/ErrorField';
import { useUndoFilters } from '../../../hooks/useUndoFilters';
import { Selector } from '../../ui/Selector';
import { NewSearchLocationsProps } from './types';
import {
  selectSearchFormCurrentCity,
  selectSearchLocationNames
} from '../../../store/selectors';
import { RegionsQueryVariables } from '../../../graphql/graphql';

export const NewSearchLocations = ({
  listType = 'search',
  formValues,
  modalParams,
  isInitialScreen,
  setInitCoordinates,
  openCitiesHandler = () => {},
  locationsPopupIsOpen,
  setLocationsIsLoading,
  toggleHandlerLocations,
  renderSubmitText,
  showSelector = true
}: NewSearchLocationsProps) => {
  const { t } = useTranslation();
  const undoFilters = useUndoFilters();
  const { values } = useFormState();
  const storedCity = useSelector(selectSearchFormCurrentCity);
  const chosenLocationNamesSearch = useSelector(selectSearchLocationNames);

  const isCreate = listType === 'create';

  const createValue = values[FORM_VALUES.locationName]
    ? [values[FORM_VALUES.locationName]]
    : [];

  const chosenLocationNames = isCreate
    ? createValue
    : chosenLocationNamesSearch;

  const cityId = formValues.city_id || storedCity;

  const locationsQueryVariables = { cityId } as RegionsQueryVariables;
  const { data: res } = useQuery(getRegions, {
    variables: locationsQueryVariables
  });

  const hasLocations = !!res?.regions?.length;

  const handleUndo = useCallback(() => {
    if (!isInitialScreen) {
      return;
    }
    undoFilters();
  }, []);

  const titleAndPlaceholderForLocationsModal = t(
    'search.locations_search.locations_placeholder.all_groups'
  );
  const popupTitle = isCreate
    ? t('new_ad.district')
    : titleAndPlaceholderForLocationsModal;

  const inputPlaceholder = isCreate
    ? t('new_ad.find_district')
    : titleAndPlaceholderForLocationsModal;

  return (
    <>
      <Field name="location_ids" component="input" type="hidden" />
      {hasLocations && showSelector && (
        <>
          <Selector
            title={t('new_ad.district')}
            cypress="chosen-locations-names"
            stat="new-search-form-locations"
            onClick={toggleHandlerLocations}
            value={chosenLocationNames.join(', ')}
          />
          <ErrorField
            field={FORM_VALUES.locationId}
            margin={chosenLocationNames?.length === 1 || !isCreate ? 0 : 15}
            cypress="location-id-field-error"
          />
        </>
      )}
      <NewSearchPopupLocations
        undo={handleUndo}
        listType={listType}
        isOpen={locationsPopupIsOpen}
        closeHandler={toggleHandlerLocations}
        inputPlaceholder={inputPlaceholder}
        popupTitle={popupTitle}
        cityId={cityId}
        openCitiesHandler={openCitiesHandler}
        setLocationsIsLoading={setLocationsIsLoading}
        hasLocations={hasLocations}
        setInitCoordinates={setInitCoordinates}
        modalParams={modalParams}
        renderSubmitText={renderSubmitText}
      />
    </>
  );
};
